import React, { useState } from "react";
import { Button, FormControl, TextareaAutosize } from "@mui/material";
import { Box, Flex, Input } from "@100mslive/roomkit-react";
import { Cross } from "../../../../icons";
import FullPageProgress from "../../../FullPageProgress";
import { ToastManager } from "../../../Toast/ToastManager";
import { SESSION_AUTH } from "../../../../common/auth";
import { ACCOUNT_SERVICES } from "../../../../services";

const AccountModulesAddPopup = props => {
  const { onClose, onUpdate } = props;
  const { isUserSession, LOGOUT_USER_SESSION } = SESSION_AUTH();

  const [name, setName] = useState("");
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);

  const onSave = async () => {
    if (!name?.trim()) {
      return ToastManager.addToast({ title: "Please enter title" });
    } else if (!content?.trim()) {
      return ToastManager.addToast({ title: "Please paste your custom code" });
    }
    setLoading(true);
    ACCOUNT_SERVICES.moduleAdd({
      userId: isUserSession.userId,
      org: isUserSession?.org?.id,
      name: name?.trim(),
      content: content,
    })
      .then(data => {
        if (data.code === 200) {
          onUpdate();
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({
          title: err?.message,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Flex
      align="center"
      direction="column"
      className="eventsPopup eventsPopup-sm"
      onClick={() => {
        onClose(false);
      }}
    >
      <Box
        className="eventsPopup-inner"
        onClick={e => {
          e.stopPropagation();
        }}
      >
        {loading && <FullPageProgress fixed={true} />}
        <div
          className="eventsPopup-close"
          onClick={() => {
            onClose(false);
          }}
        >
          <Cross />
        </div>
        <div className="eventsPopup-header">
          <div className="eventsPopup-header-heading">Custom Module</div>
        </div>
        <div className="eventsPopup-content">
          <Flex direction="column" css={{ gap: "20px" }}>
            <FormControl className="custom-form-group">
              <label
                htmlFor="module-name"
                className="custom-form-label big-label"
              >
                Title
              </label>
              <Input
                id="module-name"
                name="module"
                placeholder="Enter module title"
                className="custom-form-input"
                value={name}
                maxLength={30}
                onChange={e =>
                  setName(
                    e.target?.value?.replace(/[^a-zA-Z0-9 ]/g, "")?.slice(0, 30)
                  )
                }
              />
            </FormControl>

            <FormControl className="custom-form-group">
              <label
                htmlFor="module-content"
                className="custom-form-label big-label"
              >
                Custom code
              </label>
              <TextareaAutosize
                id="module-content"
                name="bio"
                value={content}
                onChange={e => setContent(e.target.value)}
                className="custom-form-input"
                placeholder="Paste your code here..."
                minRows={3}
                maxRows={5}
              />
            </FormControl>
          </Flex>

          <div className="events-page-account-setting-content-box-line"></div>
          <Flex align="center" justify="center">
            <Button
              color="primary"
              variant="outlined"
              className="events6ix-btn events6ix-btn-primary"
              type="button"
              onClick={onSave}
            >
              ADD Module
            </Button>
          </Flex>
        </div>
      </Box>
    </Flex>
  );
};

export default AccountModulesAddPopup;
